
import { RequestDetailEdit } from '../../../../requestDetailEdit/models/requestDetailEdit';
import { RequestAttachments } from '../../../../requestDetailEdit/models/requestAttachments';
import { INotificationService } from '../../../../../../core/notificationService';
import { RequestAllDetails} from "../../../../requestDetail/models/requestAllDetails";
import { RequestDetail} from "../../../../requestDetail/models/requestDetail";
import Detail = require("../../../../requestDetail/models/requestDetail");
import { TransportMode } from '../../../../requestList/models/transportMode';
import { RequestShipment } from '../../../../requestDetailEdit/models/requestShipment';

export class ExtraRequestDetailsController implements ng.IController {
    static $inject = ['$scope', 'NotificationService'];
   
    constructor(private _$scope: angular.IScope, private _notificationService: INotificationService) {
    }

    requestDetailEdit: RequestDetailEdit;
    isLoading: boolean;
    attachmentFormData;
    requestAllDetails: RequestAllDetails;

    $onInit() {
        this.requestDetailEdit.requestDetail.requestShipment.transportMode = "Express or LTL";
    }

    get fileUploadkey(): string {
        return "fileToUpload";
    }

    onAdditionalInstructionsChange(comments : string) {

        if (comments !== undefined && comments !== null) {


            if (this.requestAllDetails === undefined || this.requestAllDetails === null) {
                this.requestAllDetails = new RequestAllDetails(undefined);
            }

            if (this.requestAllDetails.details === undefined || this.requestAllDetails.details === null) {
                this.requestAllDetails.details = new Detail.RequestDetail(undefined);
            }

            if (this.shipmentNotUndefined()) {
                this.requestAllDetails.details.additionalInstruction = angular
                    .copy(this.requestDetailEdit.requestDetail.requestShipment.additionalInstruction);
            }

        }

    }

    onClickOfAddFile() {

        var newattachment = new RequestAttachments(undefined);
       
        if (this.attachmentsNotUndefined() && this.requestDetailEdit.requestMaterial.requestAttachments.length > 0) {
            const nextIndex = this.requestDetailEdit.requestMaterial.requestAttachments.length;
           newattachment.recordNumber = angular.copy(this
                .findNextRecordNumberForAttachments(angular.copy(this.requestDetailEdit)));
          
            this.requestDetailEdit.requestMaterial.requestAttachments[nextIndex] = newattachment;
        } else {
            
            newattachment.recordNumber = 0;
            
            this.requestDetailEdit.requestMaterial.requestAttachments[0] = newattachment;
        }

    }

    isGeneralLedgerRequired(locationCode: string): boolean {
        return locationCode === "Mail Center Darwin Building #42"
            && (this.requestDetailEdit.requestDetail.requestShipment.costCenter == undefined
                || this.requestDetailEdit.requestDetail.requestShipment.costCenter == null
                || this.requestDetailEdit.requestDetail.requestShipment.costCenter == '');
    }

    isCostCenterRequired(locationCode: string): boolean {
        return (locationCode === "Mail Center Darwin Building #42"
            && (this.requestDetailEdit.requestDetail.requestShipment.generalLedger == undefined
                    || this.requestDetailEdit.requestDetail.requestShipment.generalLedger == null
                || this.requestDetailEdit.requestDetail.requestShipment.generalLedger == ''))
            || this.requestDetailEdit.requestDetail.requestShipment.isAsset;
    }

    isShippingLocationMailCenter(locationCode: string): boolean {
        if (this.requestDetailEdit == undefined || this.requestDetailEdit == null) {
            return locationCode === "Mail Center Darwin Building #42";
        }
        else {
            return locationCode === "Mail Center Darwin Building #42"
                && ((this.requestDetailEdit.requestDetail.requestShipment.generalLedger == undefined
                    || this.requestDetailEdit.requestDetail.requestShipment.generalLedger == null
                    || this.requestDetailEdit.requestDetail.requestShipment.generalLedger == '')
                    || (this.requestDetailEdit.requestDetail.requestShipment.costCenter == undefined
                        || this.requestDetailEdit.requestDetail.requestShipment.costCenter == null
                        || this.requestDetailEdit.requestDetail.requestShipment.costCenter == ''));
        }
    }

    shipmentNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment !== undefined;
    }

    setFiles(element): void {
       
        
        var attachmentName: string = '';
        var fileuploadIndex = angular.copy(element.name);

        
        var recordNumber = angular.copy(fileuploadIndex.substring(this.fileUploadkey.length, this.fileUploadkey.length+1));
        
       
        if (element.files !== undefined && element.files.length > 0) {
           
            if (this.validateFileTypesAndSizeOfaFile(element.files[0])) {

                 this.attachmentFormData.delete(element.name);
                 this.updatedAttachmentNameToRequestDetailEdit(angular.copy(recordNumber.trim()), '');

                 attachmentName = angular.copy(element.files[0].name);

                this.attachmentFormData.append(fileuploadIndex, element.files[0]);
                this.updatedAttachmentNameToRequestDetailEdit(angular.copy(recordNumber.trim()),
                    angular.copy(attachmentName));
               
            } else {
               
                this._notificationService.showToastWithMentionedDelay("File Name of Max Length 50 Characters only Allowed. " +
                    "Attachments of maximum size 5 MB and " +
                    "file types include DOC, DOCX, GIF, JPG, PDF XLS and XLSX are only allowed.",10000);
            }
        }

        this._$scope.$apply();

        
    }


    private validateFileTypesAndSizeOfaFile(file) : boolean {
        if (file !== null) {
            var fileExtension = "";
            if (file.name.lastIndexOf(".") > 0 && file.name.length <= 50) {
                fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length);
                if ((fileExtension.toLowerCase() === "doc" ||
                    fileExtension.toLowerCase() === "docx" ||
                    fileExtension.toLowerCase() === "gif" ||
                    fileExtension.toLowerCase() === "jpg" ||
                    fileExtension.toLowerCase() === "pdf" ||
                    fileExtension.toLowerCase() === "xls" ||
                    fileExtension.toLowerCase() === "xlsx") && (file.size <= 5242880)) {
                    return true;
                }
            }
        }
        return false;
    }

    private updatedAttachmentNameToRequestDetailEdit(recordNumber, attachmentName) {
        
        if (this.attachmentsNotUndefined() && this.requestDetailEdit.requestMaterial.requestAttachments.length > 0) {

            for (var i = 0; i < this.requestDetailEdit.requestMaterial.requestAttachments.length; i++) {
                if (this.requestDetailEdit.requestMaterial.requestAttachments[i].recordNumber === Number(recordNumber)) {
                    
                    this.requestDetailEdit.requestMaterial.requestAttachments[i].attachementName = angular.copy(attachmentName);
                    return;
                }
            }
        }

    }
    

    

  

    attachmentDelete(event: MouseEvent, index: number, recordNumber: number): void {
      
        var fileUploadIndex = this.fileUploadkey + recordNumber;
      
        this.deleteAttachmentFromRequestDetailEdiTWithRecordNumber(recordNumber);
        this.attachmentFormData.delete(fileUploadIndex);
       
    }


    private deleteAttachmentFromRequestDetailEdiTWithRecordNumber(recordNumber: number) {
        if (this.attachmentsNotUndefined() && this.requestDetailEdit.requestMaterial.requestAttachments.length > 0) {

            for (var i = 0; i < this.requestDetailEdit.requestMaterial.requestAttachments.length; i++) {
                if (this.requestDetailEdit.requestMaterial.requestAttachments[i].recordNumber === recordNumber) {
                    
                    this.requestDetailEdit.requestMaterial.requestAttachments.splice(i, 1);
                    return;
                }
            }
        }
    }

    private findNextRecordNumberForAttachments(requestDetailEdit: RequestDetailEdit): number {
        var nextAttachmentRecordNumber: number = -1;
        if (this.attachmentsNotUndefined() && 
            requestDetailEdit.requestMaterial.requestAttachments.length > 0) {

            for (var eachRequestAttachment of requestDetailEdit.requestMaterial.requestAttachments) {
                if (nextAttachmentRecordNumber <= eachRequestAttachment.recordNumber) {
                    nextAttachmentRecordNumber = angular.copy(eachRequestAttachment.recordNumber);
                }
            }
        }
        
        return nextAttachmentRecordNumber + 1;
    }

    get disableAddFileButton(): boolean {
        if (this.attachmentsNotUndefined() &&
            this.requestDetailEdit.requestMaterial.requestAttachments.length >= 3) {
            return true;
        }
        return false;
    }

    isAttachmentExists(attachmentName: string): boolean {
        if (attachmentName !== undefined && attachmentName !== null && attachmentName.trim() !== '') {
            return true;
        }
        return false;
    }

    attachmentsNotUndefined(): boolean {

        if (this.requestDetailEdit != undefined && this.requestDetailEdit.requestMaterial !== undefined &&
            this.requestDetailEdit.requestMaterial.requestAttachments !== undefined) {
            return true;
        }
        return false;
    }

    formExtraRequestDetails: ng.IFormController;

    get isValid(): boolean {
       return this.formExtraRequestDetails ? this.formExtraRequestDetails.$valid : false;
    }

    set isValid(isValid: boolean) {

    }

}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/addRequest/directives/extraRequestDetails/controllers/extraRequestDetailsController.ts
 **/